/**
 * @param {string} key
 * @param {Array<int|string>} vars
 */
export const translate = (key, ...vars) => {
    return translations[key].replace(/%[ds]/g, () => vars.shift());
};
